import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { baseUrl, updateData } from '../../../../config/data'
import { loadCurrentApplicantProfile } from '../../../../config/applicantApi'

import Lang from '../../../../config/lang'
import { setPhone, setUserName } from '../../../../redux/actions/language'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useProfileTab } from '../../ProfileTabContext'

const ProfileDetail = ({
  setIsFading,
  setPublicProfileData,
  updatePercentage,
  profileCompletion,
}) => {
  const { lang } = useSelector((state) => state.globalReducer)
  const userToken = localStorage?.getItem('authToken') || ''
  const { currentTabIndex, setCurrentTabIndex } = useProfileTab()
  const [selectedValue, setSelectedValue] = useState('')
  const [selectedGender, setSelectedGender] = useState('')
  const today = new Date()
  const minimumBirthDate = new Date(
    today.getFullYear() - 55,
    today.getMonth(),
    today.getDate(),
  )
  const maximumBirthDate = new Date(
    today.getFullYear() - 16,
    today.getMonth(),
    today.getDate(),
  )
  const minDate = `${minimumBirthDate.getFullYear()}-${String(
    minimumBirthDate.getMonth() + 1,
  ).padStart(2, '0')}-${String(minimumBirthDate.getDate()).padStart(2, '0')}`
  const maxDate = `${maximumBirthDate.getFullYear()}-${String(
    maximumBirthDate.getMonth() + 1,
  ).padStart(2, '0')}-${String(maximumBirthDate.getDate()).padStart(2, '0')}`

  const dispatch = useDispatch()
  const [isEdit, setisEdit] = useState(false)
  const [fullName, setfullName] = useState('')
  const [placeOfBirth, setplaceOfBirth] = useState('')
  const [dateOfBirth, setdateOfBirth] = useState('')
  const [phoneNumber, setphoneNumber] = useState('')
  const [email, setemail] = useState('')
  const [address, setaddress] = useState('')
  const [profileData, setProfileData] = useState('')
  const [isLoading, setisLoading] = useState('')
  const [resumeURL, setresumeURL] = useState('')
  const [isFile, setisFile] = useState('')
  const [canCV, setcanCV] = useState(null)

  const uploadCV = async (file) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await axios.post(
        `${baseUrl}/Candidates/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      )

      if (response?.data) {
        const resData = response?.data
        setresumeURL(resData?.attachmentPath)
        updateProfileData(resData?.attachmentPath)
      } else {
        showError(
          `${response}`.includes('Kesalahan Jarigan') ||
            `${response}`.includes('Network Error')
            ? Lang(lang, 'internet_error')
            : response,
        )
      }
    } catch (error) {
      showError(
        `${error}`.includes('Kesalahan Jarigan') ||
          `${error}`.includes('Network Error')
          ? Lang(lang, 'internet_error')
          : error,
        `${error}`.includes('Kesalahan Jarigan') ||
          (`${error}`.includes('Network Error') &&
            Lang(lang, 'internet_error_title')),
      )
      console.log('ERROR:', error)
    }
  }

  const showError = (error, title) => {
    Swal.fire({
      title: title || 'Error!',
      text: error || 'Error',
      icon: 'error',
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        popup: 'my-custom-popup',
      },
    })
  }

  const loadJobata = async () => {
    const resData = await loadCurrentApplicantProfile({ userToken })

    if (resData) {
      dispatch(setUserName(resData.fullName))
      dispatch(setPhone(resData.mobilePhoneNumber))
      setProfileData(resData)
      setPublicProfileData(resData)
      setfullName(resData.fullName)
      setplaceOfBirth(resData.placeOfBirth)
      if (resData.dateOfBirth) {
        const formattedDOB = resData.dateOfBirth.split('T')[0]
        setdateOfBirth(formattedDOB)
      }
      setphoneNumber(resData.mobilePhoneNumber)
      setemail(resData.email)
      setaddress(resData.address)
      setSelectedValue(resData.maritalStatus)
      setSelectedGender(resData.gender || '')
      if (resData.resumeURL) {
        const resume = `${resData.resumeURL}`.includes('http')
          ? resData.resumeURL
          : `${baseUrl}/${resData.resumeURL}`
        setresumeURL(resume)
      }
    }
  }
  const isFormReady = () => {
    const isFileValid = canCV ? canCV.size <= 2 * 1024 * 1024 : false
    const isDateOfBirthValid =
      dateOfBirth && dateOfBirth >= minDate && dateOfBirth <= maxDate

    return (
      fullName &&
      selectedGender &&
      placeOfBirth &&
      phoneNumber &&
      isDateOfBirthValid &&
      email &&
      selectedValue &&
      (isFile ? isFileValid : resumeURL)
    )
  }
  function isLink(str) {
    try {
      new URL(str)
      return true
    } catch {
      return false
    }
  }

  const updateProfileData = async (url) => {
    setisLoading(true)
    const updatesData = {
      applicantID: profileData.applicantID,
      fullName: fullName,
      gender: selectedGender,
      placeOfBirth: placeOfBirth,
      dateOfBirth: dateOfBirth,
      maritalStatus: selectedValue,
      address: address,
      mobilePhoneNumber: phoneNumber,
      email: email,
      resumeURL: url ? url : resumeURL,
    }

    try {
      await updateData({
        url: 'Applicants',
        reqBody: updatesData,
        userToken,
      }).then((res) => {
        if (res?.data) {
          const resData = res?.data
          dispatch(setUserName(resData.fullName))
          dispatch(setPhone(resData.mobilePhoneNumber))
          setPublicProfileData(resData)
          setProfileData(resData)
          setisLoading(false)
          setisEdit(false)
          setIsFading(true)
          setTimeout(() => {
            if (currentTabIndex + 1 > profileCompletion) {
              updatePercentage(currentTabIndex + 1)
            }
            setCurrentTabIndex(currentTabIndex + 1)
            setIsFading(false)
          }, 200)
        } else {
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setcanCV(selectedFile)
    } else {
      alert(Lang(lang, 'please_select_a_valid_PDF_file'))

      e.target.value = null
    }
  }

  const isFormatWrong = () => {
    if (phoneNumber) {
      if (
        phoneNumber.includes('+') ||
        phoneNumber.includes('-') ||
        phoneNumber.includes(',') ||
        phoneNumber.toLowerCase().includes('e') ||
        phoneNumber.startsWith('+62') ||
        phoneNumber.startsWith('628') ||
        phoneNumber.startsWith('62') ||
        phoneNumber.startsWith('+') ||
        !phoneNumber
      ) {
        return true
      } else {
        return false
      }
    }
  }

  useEffect(() => {
    loadJobata()
  }, [])

  return (
    <div>
      <div
        className='max-w-6xl mx-auto mt-4 bg-white p-6 rounded-2xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]'
        style={{ minHeight: window.innerHeight - 300 }}
      >
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-blue-700 font-semibold text-base flex items-center space-x-2'>
            <img
              src={'/asset/icon/profile_blue.svg'}
              className='w-[16px] mr-1'
            />
            <span>Profile Detail</span>
          </h2>
          {!isEdit && (
            <button
              onClick={() => setisEdit(true)}
              className='flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 text-white bg-red-500 hover:bg-red-600'
            >
              <img src={'/asset/icon/edit.svg'} className='w-[16px] mr-1' />
              Edit
            </button>
          )}
        </div>

        <form className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4 text-sm text-gray-700'>
          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'full_name')} <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              disabled={!isEdit}
              value={fullName}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
              onChange={(e) => setfullName(e.target.value)}
            />
          </div>
          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'place_of_birth')}{' '}
              <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              disabled={!isEdit}
              value={placeOfBirth}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
              onChange={(e) => setplaceOfBirth(e.target.value)}
            />
          </div>
          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'date_of_birth')}{' '}
              <span className='text-red-500'>*</span>
            </label>
            <input
              type='date'
              disabled={!isEdit}
              min={minDate}
              max={maxDate}
              value={dateOfBirth}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
              onChange={(e) => setdateOfBirth(e.target.value)}
            />
            {dateOfBirth &&
              (dateOfBirth < minDate || dateOfBirth > maxDate) && (
                <p className='text-red-500 text-xs mt-1'>
                  {Lang(lang, 'date_of_birth_age_range_error')}
                </p>
              )}
          </div>

          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'gender')} <span className='text-red-500'>*</span>
            </label>

            <div className='relative w-full'>
              <select
                value={selectedGender}
                disabled={!isEdit}
                onChange={(e) => setSelectedGender(e.target.value)}
                className={
                  (isEdit ? 'bg-white' : 'bg-gray-100') +
                  ' appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
                }
              >
                <option value='' disabled>
                  -- Pilih Gender --
                </option>
                <option value='Male'>Male</option>
                <option value='Female'>Female</option>
              </select>

              <div className='pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500'>
                ▼
              </div>
            </div>
          </div>

          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'phone_number')}{' '}
              <span className='text-red-500'>*</span>
            </label>
            {/* <div className="mb-6">
              <div className="flex flex-row rounded-l-[35px]">
                <div className={`border-[#48494B] flex h-[60px] w-[60px] job-form items-center justify-center rounded-l-[35px]`} >
                  <p className="font-medium">{'+62'}</p>
                </div>
                <input type="number" id="phone" value={phoneNumber} className={(isEdit ? 'bg-white' : 'bg-gray-100') + ` rounded-r-[35px] job-form border-[#48494B] text-sm p-[16px] pl-[20px] w-full h-[60px] appearance-none`} required onChange={(e) => setphoneNumber(e.target.value)} />
              </div>
              </div> */}

            <input
              type='number'
              disabled={!isEdit}
              value={phoneNumber}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
              onChange={(e) => setphoneNumber(e.target.value)}
            />
            {isFormatWrong() && (
              <p className='text-red-500 text-xs mt-1'>
                {Lang(lang, 'phone_number_format_wrong')}
              </p>
            )}
          </div>
          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'email_address')}{' '}
              <span className='text-red-500'>*</span>
            </label>
            <input
              type='text'
              disabled={true}
              readOnly
              value={email}
              className={
                'bg-gray-100 w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
            />
          </div>

          <div>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'marital_status')}{' '}
              <span className='text-red-500'>*</span>
            </label>

            <div className='relative w-full'>
              <select
                value={selectedValue}
                disabled={!isEdit}
                onChange={(e) => setSelectedValue(e.target.value)}
                className={
                  (isEdit ? 'bg-white' : 'bg-gray-100') +
                  ' appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
                }
              >
                <option value='' disabled>
                  -- Pilih Status --
                </option>
                <option value='Lajang'>Lajang</option>
                <option value='Menikah'>Menikah</option>
              </select>

              <div className='pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500'>
                ▼
              </div>
            </div>
          </div>

          <div className='sm:col-span-2 lg:col-span-3'>
            <label className='block mb-1 font-medium'>
              {Lang(lang, 'current_address')}
            </label>
            <textarea
              disabled={!isEdit}
              value={address}
              onChange={(e) => setaddress(e.target.value)}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-xl border border-gray-200 px-4 py-2 resize-none'
              }
              rows={2}
            />
          </div>
        </form>

        <div>
          <div
            className={`flex justify-start gap-3 items-center text-sm ${isEdit && 'mb-1'} w-full mt-3`}
          >
            <label className='block mb-1 font-medium'>
              CV<span className='text-red-500'>*</span>
            </label>
            {isEdit && (
              <label className='flex items-center space-x-2'>
                <input
                  type='checkbox'
                  disabled={!isEdit}
                  className='form-checkbox text-red-500 mb-1'
                  checked={isFile}
                  onChange={(e) => {
                    setisFile(!isFile)
                    setcanCV(null)
                  }}
                />
                <span className='text-gray-700'>
                  {Lang(lang, 'uploadFile')}
                </span>
              </label>
            )}
          </div>
          {!isEdit && resumeURL ? (
            <a
              href={resumeURL}
              target='_blank'
              onClick={(e) => {}}
              className='flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]'
            >
              <img src='/asset/icon/view_file.svg' className='w-[30px]' />
              <p class='font-medium text-[13px] ml-2 mt-1'>Curriculum Vitae</p>
            </a>
          ) : isFile ? (
            <input
              type='file'
              id='subject'
              className={`rounded-[35px] job-form border-[#48494B] text-sm p-[16px] pl-[20px] w-full h-[60px] flex flex-col items-center`}
              accept='application/pdf'
              required={true}
              onChange={handleFileChange}
            />
          ) : (
            <input
              type='text'
              disabled={!isEdit}
              value={resumeURL}
              className={
                (isEdit ? 'bg-white' : 'bg-gray-100') +
                ' w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]'
              }
              onChange={(e) => setresumeURL(e.target.value)}
            />
          )}
          {canCV && canCV.size >= 2 * 1024 * 1024 && (
            <div className='flex justify-start w-full'>
              <p className='text-red-500 text-xs mt-1 mr-0'>
                {'PDF file maximum size 2 MB'}
              </p>
            </div>
          )}
          {resumeURL && !isLink(resumeURL) && (
            <div className='flex justify-start w-full'>
              <p className='text-red-500 text-xs mt-1 mr-0'>
                {Lang(lang, 'invalid_link')}
              </p>
            </div>
          )}
        </div>

        {!isFormReady() && (
          <div className='flex justify-end w-full'>
            <p className='text-red-500 text-xs mt-1 ml-0'>
              {Lang(lang, 'required_error')}
            </p>
          </div>
        )}
      </div>

      <div className='flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3'>
        <button
          type='submit'
          className={
            'rounded-full px-4 py-1 text-sm ' +
            (isEdit
              ? `text-white ${isFormReady() ? 'bg-red-500' : 'bg-gray-300'} hover:${isFormReady() ? 'bg-red-600' : 'bg-gray-300'}`
              : `text-red-500 border border-red-500 hover:bg-gray-50 ${!isFormReady() && 'bg-gray-300'}`)
          }
          onClick={() => {
            if (isFormReady() && !isFormatWrong()) {
              if (isEdit && !isLoading) {
                if (canCV) {
                  uploadCV(canCV)
                } else {
                  if (resumeURL && isLink(resumeURL)) {
                    updateProfileData()
                  }
                }
              } else {
                setIsFading(true)
                setTimeout(() => {
                  if (currentTabIndex + 1 > profileCompletion) {
                    updatePercentage(currentTabIndex + 1)
                  }
                  setCurrentTabIndex(currentTabIndex + 1)
                  setIsFading(false)
                }, 200)
              }
            }
          }}
        >
          {isLoading ? (
            <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto' />
          ) : (
            `${isEdit ? Lang(lang, 'save_and_next') : Lang(lang, 'next')}${!isEdit ? ` ${currentTabIndex + 1}/10` : ''}`
          )}
        </button>
      </div>
    </div>
  )
}

export default ProfileDetail
